module.exports = __webpack_public_path__ + "media/images/pack-01-675d8b8f181a2c4b72f29dde1336f8e4.webp";